export default __webpack_public_path__ + "static/popup-editor-e81ef64edfd0dbc78a573848f31ebc0f.png";